import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoadingTask } from "../tools/ui/loading-task";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { StrategyDTO } from "./dto/strategy.dto";
import { Strategy } from "../domain/GS/strategy";
import { mapper } from "../tools/mapping/mapper";

@Injectable({
    providedIn: 'root',
})
export class StrategyService extends BaseService {

    private serviceUrl = `${environment.GSServiceBaseUrl}api/strategy`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getUpcomingAvantTravaux(analyticalUnitCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/upcomingAvantTravaux/${analyticalUnitCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getUpcomingAvantTravaux')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: StrategyDTO[]) => {
                return response.map((item: StrategyDTO) => {
                    return mapper.map(item, StrategyDTO, Strategy);
                });
            }));
    }
}